// extracted by mini-css-extract-plugin
export default {"reset":"TkMewD","visuallyHidden":"KXNI3T"};